import {useDispatch} from "react-redux";
import React from "react";
import {SVGComponent} from "@/util/type/StoreTypes.ts";
import {base} from "@/store/modules/base.ts";
import {DefaultButton} from "@/components/buttons/DefaultButton.tsx";
import {RoundedWrapper} from "@/components/wrapper/RoundedWrapper.tsx";
import { X } from "lucide-react";

interface BaseModalProps {
    title?: string;
    icon?: SVGComponent;
    image?: string;
    subtitle?: string;
    onClose?: () => void;
    showHeader?: boolean;
    children?: React.ReactNode;
    size?: 'sm' | 'xs' | 'md' | 'lg' | 'xl'
}

export const BaseModal = ({
                              title,
                              onClose,
                              icon: Icon,
                              image,
                              showHeader = true,
                              size = "sm",
                              subtitle,
                              children
                          }: BaseModalProps) => {
    const dispatch = useDispatch<any>();

    function handleClose() {
        dispatch(base.mutation.resetModalOptions())
        onClose && onClose()
    }

    const width = size == 'md' ? '!w-[700px]' : size == 'lg' ? '!w-[900px]' : size == 'xl' ? '!w-[1200px]' : size == 'sm' ? '!w-[500px]' : '!w-[300px]'

    return (
        <>
            <div style={{overflowX: "auto",}}
                 className="justify-center items-center flex  overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                <div className={`relative w-auto my-6 mx-auto max-h-screen ${width}`}>
                    {/*content*/}
                    <div
                        className="border-0 rounded-xl shadow-lg relative flex flex-col w-full   bg-white outline-none focus:outline-none">
                        {/*header*/}
                        {
                            showHeader && (
                                <div style={{display: "flex"}} className="items-start w-full    justify-between p-5 border-b border-solid border-blueGray-200">
                                    <div style={{display: "flex"}} className={'items-center w-full'}>
                                        <div>{
                                            !image ?
                                                <div>
                                                    {Icon && <Icon className={'w-[20px] h-[20px]'}/>}
                                               </div> :
                                                <img src={image} alt="" className={'w-[40px] h-[40px]'}/>
                                        }
</div>
                                        <div style={{display:'flex',
                                            flexDirection:'column',alignItems:'start',textAlign:'start' }} className="text-start ml-10">
                                            
                                                <h3 className="text-[16px]  mb-0 font-semibold" style={{marginTop:0}}>{title}</h3>
                                                {subtitle&& <h6 className="text-[12px] mt-0.5">{subtitle}</h6>}
                                        </div>
                                    </div>

                                    <DefaultButton className={''} onClick={handleClose} bgType={'normal'}>
                                        <span
                                            className="bg-transparent text-black opacity-20 h-12 w-12 text-2xl block outline-none focus:outline-none"><X /></span>
                                    </DefaultButton>

                                </div>
                            )
                        }
                        {children}
                    </div>
                </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
    )
}
